import { render, staticRenderFns } from "./vpn.vue?vue&type=template&id=b67859fa&scoped=true&"
import script from "./vpn.vue?vue&type=script&lang=js&"
export * from "./vpn.vue?vue&type=script&lang=js&"
import style0 from "./vpn.vue?vue&type=style&index=0&id=b67859fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67859fa",
  null
  
)

export default component.exports